import { initRatingForm } from "Functions/rating";
import { Vue, i18n } from "Common/vue";
import ShippingInfo from "VueComponents/ShippingInfo.vue";
import Ratings from "VueComponents/Ratings.vue";
import Swiper, { Pagination, Navigation } from "swiper";
import { initAnchors } from "Functions/anchor";
import { initCountdowns } from "Functions/countdown";

import "Layouts/default";

import "Ui/slider";
import "Ui/toggle";
import "Ui/more-items";
import "Ui/star-rating";

import "Common/social";
import "Common/lightgallery";

import "Components/seen-products";
import "Components/modal/modal-remote";
import "Components/modal/modal-watchdog";
import "Components/form/contact-supplier";

import "./product-jquery";

initRatingForm();

if (document.querySelector(".js-ratings-box")) {
    window.$_ratings = new Vue({
        i18n,
        render: (h) => h(Ratings),
    }).$mount(".js-ratings-box");

    document.querySelectorAll(".js-trigger-rating-filter").forEach((trigger) => {
        trigger.addEventListener("click", (event) => {
            const starsNumber = trigger.dataset.starsNumber;
            const ratingsCount = trigger.dataset.ratingsCount;

            rEvent.dispatch("Rating.triggerFilter", starsNumber, ratingsCount);
        });
    });
}

document.querySelectorAll('[data-has-component="shippingInfo"]').forEach((element) => {
    new Vue({
        el: element,
        components: {
            ShippingInfo,
        },
    });

    element.removeAttribute("data-has-component");
});

document.addEventListener("DOMContentLoaded", function () {
    initAnchors();
    initCountdowns();

    if (document.querySelector(".js-set-tabs-nav")) {
        function checkSetTabsArrow() {
            const arrow = document.querySelector(".js-set-tabs-arrow"),
                navHolder = document.querySelector(".js-set-tabs-nav"),
                navHolderInfo = navHolder.getBoundingClientRect(),
                lastElem = navHolder.querySelector(".c-content-nav__item:last-child"),
                lastElemInfo = lastElem.getBoundingClientRect();

            arrow.classList.toggle(
                "is-hidden",
                lastElem.offsetLeft + lastElemInfo.width <= navHolderInfo.width
            );
        }

        checkSetTabsArrow();

        document.querySelector(".js-set-tabs-nav").addEventListener("scroll", function () {
            checkSetTabsArrow();
        });

        document.querySelectorAll(".c-content-nav__item").forEach((trigger) => {
            trigger.addEventListener("click", function () {
                const navHolder = document.querySelector(".js-set-tabs-nav");

                navHolder.scroll({
                    left: trigger.offsetLeft,
                    behavior: "smooth",
                });
            });
        });

        document.querySelector(".js-set-tabs-arrow").addEventListener("click", () => {
            const navHolder = document.querySelector(".js-set-tabs-nav"),
                elemInfo = navHolder
                    .querySelector(".c-content-nav__item:last-child")
                    .getBoundingClientRect(),
                navHolderInfo = navHolder.getBoundingClientRect();

            if (navHolder.querySelector(".c-content-nav__item.is-active").nextElementSibling) {
                navHolder
                    .querySelector(".c-content-nav__item.is-active")
                    .nextElementSibling.click();
            } else {
                navHolder.querySelector(".c-content-nav__item:first-child").click();
            }
        });

        window.rEvent.on("Window.resized", () => {
            checkSetTabsArrow();
        });
    }
});
